export function bufferToBase64(buf: ArrayBuffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buf)))
}

export function blobToDataURL(blob: Blob): Promise<string> {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.addEventListener('load', () => {
      const url = reader.result as string
      resolve(url)
    }, false)
    reader.addEventListener('error', (e) => {
      reject(e)
    }, false)
    reader.readAsDataURL(blob)
  })
}

export async function blobToBase64(blob: Blob): Promise<string> {
  // return blob.arrayBuffer().then(bufferToBase64)
  const url = await blobToDataURL(blob);
  return url.replace(/^data.*?base64,/, '');
}

export function stringToBuffer (str: string): Promise<ArrayBuffer> {
  return new Response(str).arrayBuffer()
}

export function bufferToString (buffer: ArrayBuffer): Promise<string> {
  return new Response(buffer).text()
}

// https://github.com/Netflix/NfWebCrypto/pull/4/files
export function stringToUint8 (s: string): Uint8Array {
  const enc = new TextEncoder()
  return enc.encode(s)
}

export function uint8ToString (uint8: Uint8Array): string {
  const enc = new TextDecoder()
  return enc.decode(uint8)
}

export function stringToUint16 (s: string): Uint16Array {
  const l = []
  for (let i = 0; i < s.length; i++) {
    l.push(s.charCodeAt(i))
  }
  return new Uint16Array(l)
}

export function uint16ToString (buffer: Uint16Array): string {
  const enc = new TextDecoder('utf-16')
  return enc.decode(buffer)
}

// UTF-32 functions
export function stringToUint32(s: string): Uint32Array {
  const codePoints = []
  for (let i = 0; i < s.length; i++) {
    // 处理代理对（surrogate pairs）
    const code = s.codePointAt(i)
    if (code !== undefined) {
      // 如果是代理对，需要跳过下一个字符
      if (code > 0xFFFF) {
        i++ // 跳过代理对的下一个字符
      }
      codePoints.push(code)
    }
  }
  return new Uint32Array(codePoints)
}

export function uint32ToString(uint32: Uint32Array): string {
  return Array.from(uint32)
    .map(codePoint => String.fromCodePoint(codePoint))
    .join('')
}

export function download (urlOrBlob: string | Blob, filename?: string) {
  const a = document.createElement('a')
  let url = typeof urlOrBlob === 'string' ? urlOrBlob : URL.createObjectURL(urlOrBlob)

  if (typeof url !== 'string') {
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 10_000)
  }
  a.href = url
  a.download = filename || 'download'
  a.rel = 'noopener'
  // a.click()
  a.dispatchEvent(new MouseEvent('click'))
}
